import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";

import AddReferralModal from "./AddReferralModal";
import DeleteModal from "./DeleteModal";
import ErrorModal from "./ErrorModal";
import SuccessModal from "./SuccessModal";

export default function Modals({
  caseId,
  modals,
  setModals,
  modalInfo,
  parseData,
  handleSuccessModal,
  handleFailureModal,
  handleRequestSuccess,
  errorArray,
  selectedReferrals,
}) {
  const referralsRepository = inject("repositories/referral-repository");

  const handleDelete = async () => {
    try {
      const postData = selectedReferrals;
      await referralsRepository.deleteBulk(postData).then((_) => {
        handleSuccessModal("Success", "Successfully Deleted");
      });
    } catch (error) {
      handleFailureModal("Failure", "Failed to delete referral/s", error);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const parsedPostData = parseData(data);
      await referralsRepository.createBulk(parsedPostData).then((_) => {
        handleSuccessModal("Success", "Successfully Added");
      });
    } catch (error) {
      handleFailureModal("Failure", "Failed to add referral/s", error);
    }
  };
  return (
    <>
      <AddReferralModal
        caseId={caseId}
        open={modals.add}
        onClose={() => setModals((m) => ({ ...m, add: false }))}
        onSubmit={handleSubmit}
      />
      <SuccessModal
        title={modalInfo.title}
        desc={modalInfo.desc}
        open={modals.success}
        setOpen={(v) => setModals((m) => ({ ...m, success: v }))}
        onClose={handleRequestSuccess}
      />
      <ErrorModal
        title={modalInfo.title}
        desc={modalInfo.desc}
        open={modals.error}
        setOpen={(v) => setModals((m) => ({ ...m, error: v }))}
        errorArray={errorArray}
      />
      <DeleteModal
        open={modals.delete}
        onClose={() => setModals((m) => ({ ...m, delete: false }))}
        onDelete={handleDelete}
      />
    </>
  );
}
